import { render, staticRenderFns } from "./ApocRecordBar.vue?vue&type=template&id=97d03338&scoped=true"
import script from "./ApocRecordBar.vue?vue&type=script&lang=js"
export * from "./ApocRecordBar.vue?vue&type=script&lang=js"
import style0 from "./ApocRecordBar.vue?vue&type=style&index=0&id=97d03338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d03338",
  null
  
)

export default component.exports